import { notificationDefinitions } from './notificationDefinitions'

export const isNotification = (taskType: string): boolean =>
  taskType in notificationDefinitions
